import styled from "styled-components";
import VehicleStatusImage from "../assets/vehicle-empty-state-background.svg";

export const StationVehiclesStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #1b1b1b;
  height: 100%;
  position: relative;
  padding-bottom: 72px;
`;

export const SubtitleStyled = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 24px;
  color: #606060;
`;

export const EmptyStateStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  background: #e9e9e9 url(${VehicleStatusImage}) no-repeat bottom right;
  height: 380px;

  h3 {
    font-size: 24px;
    font-weight: 500;
  }
`;

interface ActionButtonProps {
  isConfirmationRequired?: boolean;
  isCancel?: boolean;
  isDone?: boolean;
  isDisplayOnly?: boolean;
}

interface VehicleWrapperProps {
  isLastOne: boolean;
}

export const VehicleWrapperStyled = styled.div<VehicleWrapperProps>`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 12px 12px 12px 0;
  border-top: 1px solid #f4f4f4;
  border-bottom: ${(props) => (props.isLastOne ? "1px solid #f4f4f4" : "none")};
`;

export const VisualStyled = styled.div`
  display: flex;
  gap: 8px;
  font-size: 16px;
  align-items: center;
  min-width: 400px;
`;

export const ImageStyled = styled.img`
  display: flex;
  align-items: center;
  width: 50px;
  height: 50px;
`;

export const StateStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  align-items: flex-start;
  justify-content: center;
  min-width: 400px;

  div:first-child {
    font-size: 20px;
    font-weight: 500;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
  width: 500px;
  align-items: center;
`;

export const ActionButton = styled.button<ActionButtonProps>`
  display: flex;
  gap: 4px;
  align-items: center;
  border-style: solid;
  justify-content: center;
  font-size: ${(props) => (props.isCancel ? "14px" : "20px")};
  border-width: 2px;
  border-style: solid;
  background-color: ${(props) =>
    props.isDisplayOnly
      ? "rgba(15, 98, 95, 0.2)"
      : props.isConfirmationRequired
      ? "#0f625f"
      : props.isCancel
      ? "#fff"
      : "#f0e0d1"};
  border-color: ${(props) =>
    props.isDone
      ? "#864c13"
      : props.isDisplayOnly
      ? "#0f625f"
      : props.isConfirmationRequired
      ? "#3f7f7d"
      : props.isCancel
      ? "#e0a3a3"
      : "#fff"};
  color: ${(props) =>
    props.isDone
      ? "#864c13"
      : props.isDisplayOnly
      ? "#0f625f"
      : props.isConfirmationRequired
      ? "#fff"
      : props.isCancel
      ? "#b21919"
      : "#864c13"};
  cursor: ${(props) =>
    !props.isDone && !props.isDisplayOnly ? "pointer" : "default"};
  min-width: ${(props) => (!props.isCancel ? "230px" : "auto")};
  min-height: ${(props) => (!props.isCancel ? "65px" : "auto")};
  padding: ${(props) => (!props.isCancel ? "0" : "8px")};
`;

export const RefreshButtonStyled = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #d9e5e5;
  border: none;
  border-radius: 4px;
  color: #1b1b1b;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const StationWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-bottom: 72px; // altura do footer
  box-sizing: border-box;
`;

export const StationFooterStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  color: #606060;
  font-size: 14px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  padding: 16px 24px;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  z-index: 100;
`;

export const VehicleListScrollArea = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
`;
